import type { IconProps } from './types';

function ShieldCheckIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M5.53463 13.4785C5.68223 13.5646 5.75602 13.6076 5.86017 13.63C5.941 13.6473 6.05892 13.6473 6.13975 13.63C6.2439 13.6076 6.31769 13.5646 6.46529 13.4785C7.76399 12.7208 11.3333 10.3409 11.3333 7.06857V4.53523C11.3333 3.8193 11.3333 3.46134 11.2229 3.20723C11.1108 2.94897 10.999 2.81158 10.769 2.64917C10.5427 2.48938 10.099 2.39712 9.21176 2.21258C8.23383 2.00919 7.48281 1.64193 6.79621 1.11078C6.46696 0.856079 6.30234 0.728728 6.17352 0.693993C6.03759 0.657341 5.96233 0.657341 5.8264 0.693993C5.69758 0.728728 5.53295 0.856079 5.20371 1.11078C4.51711 1.64193 3.76609 2.00919 2.78816 2.21258C1.90088 2.39712 1.45723 2.48938 1.23092 2.64917C1.00091 2.81158 0.88915 2.94897 0.776984 3.20723C0.666626 3.46134 0.666626 3.8193 0.666626 4.53523V7.06857C0.666626 10.3409 4.23593 12.7208 5.53463 13.4785Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { ShieldCheckIcon };
